import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getLangFromPathname, isSupportedLang } from '@/utils/localeFromUrl'

/**
 * `t` bound to the language segment in the URL (/ar/..., /en/...), so copy matches
 * the visible locale even when i18n.language is briefly out of sync with the route.
 */
export function useRouteTranslation() {
  const { pathname } = useLocation()
  const { i18n } = useTranslation()

  const lng = useMemo(() => {
    const fromUrl = getLangFromPathname(pathname)
    if (fromUrl && isSupportedLang(fromUrl)) return fromUrl
    return (i18n.language || 'ar').split('-')[0].toLowerCase()
  }, [pathname, i18n.language])

  useEffect(() => {
    const want = getLangFromPathname(pathname)
    if (!isSupportedLang(want)) return
    const have = i18n.language?.split('-')[0].toLowerCase()
    if (have !== want) {
      void i18n.changeLanguage(want)
    }
  }, [pathname, i18n])

  const t = useMemo(() => i18n.getFixedT(lng, 'translation'), [i18n, lng])

  return { t, i18n, lng }
}
